module.exports = __webpack_public_path__ + "static/img/pagegongzhonghao_01.cbdcd4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pagegongzhonghao_01.png
// module id = eR6p
// module chunks = 0